import React, { useEffect } from 'react';
import { FaChartLine, FaNetworkWired, FaVectorSquare, FaLaptopCode } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Marketing from '../Images/Marketing.webp';
import Hiring from '../Images/Hiring.webp';
import Design from '../Images/Design.webp';
import WebDev from '../Images/WebDev.webp';

const services = [
  {
    icon: FaChartLine,
    title: 'Marketing',
    gradient: 'bg-gradient-to-br from-[#3B82F6] via-[#6366F1] to-[#8B5CF6]',
    hoverRing: 'hover:ring-blue-300',
    description: 'Innovative marketing strategies to elevate your brand and drive sustainable growth.',
    link: '/services/marketing',
    bgImage: Marketing 
  },
  {
    icon: FaNetworkWired,
    title: 'Hiring',
    gradient: 'bg-gradient-to-br from-[#10B981] via-[#14B8A6] to-[#0D9488]',
    hoverRing: 'hover:ring-green-300',
    description: 'Strategic recruitment solutions to build high-performance, diverse teams.',
    link: '/services/hiring',
    bgImage: Hiring
  },
  {
    icon: FaVectorSquare,
    title: 'Graphic Design',
    gradient: 'bg-gradient-to-br from-[#EC4899] via-[#DB2777] to-[#BE185D]',
    hoverRing: 'hover:ring-pink-300',
    description: 'Innovative visual branding that tells your unique organizational story.',
    link: '/services/graphic-design',
    bgImage: Design
  },
  {
    icon: FaLaptopCode,
    title: 'Software Development',
    gradient: 'bg-gradient-to-br from-[#4A5568] via-[#2D3748] to-[#1A202C]',
    hoverRing: 'hover:ring-gray-300',
    description: 'Cutting-edge technological solutions transforming your digital ecosystem.',
    link: '/services/software-development',
    bgImage: WebDev
  }
];

const ServiceCard = ({ icon: Icon, title, gradient, hoverRing, description, link, bgImage }) => {
  return (
    <Link to={link} className="block transform transition-all duration-300 hover:scale-105">
      <div className={`
    group relative overflow-hidden rounded-2xl shadow-xl 
    w-full h-72 cursor-pointer 
    transition-all duration-300 
    ${hoverRing}
    hover:shadow-2xl hover:ring-4 hover:ring-opacity-50
  `}>
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src={bgImage}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
        {/* Content */}
        <div className="hover:bg-black/50 relative z-10 flex flex-col justify-center items-center h-full p-6 text-white">
          <div className='flex items-center justify-center h-full'>
            <p className="text-sm text-center font-semibold opacity-100 md:opacity-0 translate-y-0 md:translate-y-10 
          transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 
          text-shadow">
              {description}
            </p>
          </div>
          {/* Arrow Icon */}
          <div className="absolute bottom-4 right-4 opacity-100 md:opacity-0 
        group-hover:opacity-100 transition-all duration-300 
        transform group-hover:translate-x-[-10px]">
            <svg xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mt-16 md:mt-0 flex justify-center items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-transparent bg-clip-text 
            bg-gradient-to-r from-blue-600 to-purple-600 mb-4">
            Our Professional Services
          </h2>
          <p className="text-xl text-black max-w-2xl mx-auto">
            Comprehensive solutions designed to accelerate your business transformation
          </p>
        </div>

        <div className="w-full px-4 sm:px-6 lg:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 justify-center">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              {...service}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;